import { Toaster } from '@/components/ui/sonner';
import { QueryClientProviderWrapper } from '@/providers/QueryClientProvider';
import { ErrorBoundary } from '@/components/ErrorBoundary';

import { RouterProvider } from 'react-router';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import { router } from './router';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from './providers/ThemeProvider';
import { ProductFruitsIntegration } from './components/ProductFruitsIntegration';
import { AppUpdateNotifier } from './components/AppUpdateNotifier';

export function App() {
  return (
    <QueryClientProviderWrapper>
      <I18nextProvider i18n={i18n} defaultNS="translation">
        <ThemeProvider>
          <ErrorBoundary>
            <NuqsAdapter>
              <RouterProvider router={router} />
              <ProductFruitsIntegration />
              <AppUpdateNotifier />
              <Toaster />
            </NuqsAdapter>
          </ErrorBoundary>
        </ThemeProvider>
      </I18nextProvider>
    </QueryClientProviderWrapper>
  );
}

export default App;
